import { entityName, interactionId } from "./interactionIds";
import { gtag } from "./googleAnalytics";

export const collectGAEvent = function (
  eventName:
    | Gtag.EventNames
    | "command"
    | "invalidCommand"
    | "suggestionClicked"
    | "predefinedButtonClicked"
    | "pageDialog"
    | "viewTab"
    | "exception"
    | "workItem"
    | "menuItem"
    | "navRailButton",
  eventParams?: Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams
) {
  gtag("event", eventName, {
    ...eventParams,
    interaction_id: interactionId,
    entity_name: entityName,
    event_time: Date.now(),
  });
};
